import { render, staticRenderFns } from "./ListDot.vue?vue&type=template&id=21613e68&"
import script from "./ListDot.vue?vue&type=script&lang=js&"
export * from "./ListDot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports